/**
 * @namespace Stores
 * @category Stores
 * @module sidebar-store
 * */

export default {
  namespaced: true,
  state: {
    /**
     * Sidebar can be expanded (wider)
     * When expanded, we can see module names and account options.
     */
    isExpanded: false,
    /**
     * The sidebar can contain a layer that prevents to click button (e.g. settings overlay)
     */
    hasBackdrop: false,
  },
  getters: {
    isSidebarExpanded(state) {
      return state.isExpanded
    },
    hasBackdrop(state) {
      return state.hasBackdrop
    },
  },
  mutations: {
    setIsExpanded(state, value) {
      state.isExpanded = value
    },
    setHasBackdrop(state, value) {
      state.hasBackdrop = value
    },
  },
  actions: {
    setIsExpanded({ commit }, value) {
      commit('setIsExpanded', value)
    },
    setHasBackdrop({ commit }, value) {
      commit('setHasBackdrop', value)
    },
  },
}
